var map = {
	"./Flags.jpg": 6708,
	"./FlagsA.jpg": 7853,
	"./alexey_rogov.jpg": 5417,
	"./bg-1.jpg": 5401,
	"./bg-1aa.jpg": 7024,
	"./bg-6.jpg": 4275,
	"./bg-6aaa.jpg": 598,
	"./bg-wide.jpg": 3296,
	"./bg-widea.jpg": 1173,
	"./liubov_bush.jpg": 9588,
	"./liubov_bushф.jpg": 1337,
	"./logo.svg": 2835,
	"./news-1.jpg": 6837,
	"./news-2.jpg": 4978,
	"./news-3.jpg": 1379,
	"./news-4.jpg": 9428,
	"./pavel_me.jpg": 9950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;